module.exports = __webpack_public_path__ + "static/media/2.9ddca212.jpg";